const useIncidentsStyles = () => {
    return {
        saveDocumentButtonStyles: {
            width: 36,
            height: 36,
            borderRadius: 500,
            minWidth: 'unset',
        },
    };
};
export default useIncidentsStyles;
